<template>
  <component :is="compDef"></component>
</template>

<script>
  export default {
    name: "comp-wrapper",
    props:["params"], //{template,dataSource,script,style,mixin}
    data() {
      let outer=this;
      let comp={
        template:this.params.template,
        data(){
          let obj={
            context:outer.params.context,
            siteId:outer.params.siteId
          };
          _.each(outer.params.dataSource,({key})=>obj[key]="")
          return obj;
        },
        methods:{
          call(methodName,...args){
            if(this.__scriptEval){
              let method=this.__scriptEval(methodName)
              if(method){
                method.apply(this,args);
              }
            }
          },
          reloadData(dataKey,ctx){
            if(ctx)_.assign(this.context,ctx);
            let ds=outer.params.dataSource.filter(ds=>ds.key===dataKey)[0]
            if(ds){
              //包一层Promise,让getData函数可以直接返回数据而不是promise
              Promise.resolve(ds.getData()).then(data=>this[dataKey]=data)
            }else{
              if(window.console)console.log("不存在数据源:"+dataKey)
            }
          }
        }
      };
      if(this.params.mixin){
        comp.mixins=[this.params.mixin]
      }
      comp.mounted=function(){
        if(outer.params.script){
          let fn;
          try{
            let $script = `
            ` + outer.params.script + `
              return function(exp){
                  return eval("(0,"+exp+")");
              }
            `;
            fn=new Function($script)
          }catch(e){
            if(window.console){
              console.log(outer.params.script);
              console.log(e)
            }
          }

          if(fn){
            this.__scriptEval=fn.call(this);
          }
        }
        if(outer.params.dataSource){
          outer.fetchData(outer.params.dataSource).then(arr=>{
            if(arr){
              arr.forEach(([key,v])=>{
                this[key]=v
              })
            }
          })
        }
      }
      return {
        compDef:comp,
        cssEl:null,
      }
    },
    mounted() {
      if(this.params.style){
        this.insertCss(this.params.style)
      }

    },
    methods:{
      destroy(){
        if(this.cssEl){
          this.cssEl.remove();
        }
      },
      insertCss:function(css){
        if(!css)return;
        this.cssEl=$("<style type='text/css'></style>").html(css).insertBefore(this.$el);
      },
      fetchData(dataSource){
        //[{key,ds,getData}]=>promise([[dataKey,data]])
        if(!dataSource) return Promise.resolve(null);
        let promises=dataSource.map(v=>_.isFunction(v.getData) && v.getData());
        let keys=dataSource.map(d=>d.key);
        return Promise.all(promises).then(values=>{
          return _.zip(keys,values)
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/comp-wrapper.vue